import { GocardlessWebhookInterface } from 'modules/profile/payment-gateways/integrations/gocardless/types'
import httpClient from 'shared/utils/http-client'

export const GOCARDLESS_ACCOUNT_API = '/api/payment/integration/gocardless/account'

export const gocardlessDisconnect = () => httpClient.get(`${GOCARDLESS_ACCOUNT_API}/disconnect`)

export const updateGocardlessWebhookSecret = (data: GocardlessWebhookInterface) =>
  httpClient.put(`${GOCARDLESS_ACCOUNT_API}/webhook-secret`, data)
